import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

export const GoBackButton = ({ onClick }) => (
    <Button
        type="primary"
        shape="circle"
        size="large"
        icon={<ArrowLeftOutlined />}
        onClick={onClick}
    />
);